import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

export const fetchDepartments = async () => {
  try {
    const response = await axiosInstance.get(API.department.getList);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
};

export const fetchEmployees = async (departmentId) => {
  try {
    const response = await axiosInstance.get(API.performanceReview.getLatestReviews(departmentId));

    // Point 13: response is now { period, data }. The review list lives under
    // data (fallback to the raw body if the backend hasn't switched yet).
    const list =
      response.data && response.data.data !== undefined ? response.data.data : response.data;

    if (Array.isArray(list)) {
      return list;
    } else {
      console.error("Invalid response format");
      return [];
    }
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};


